import { render, staticRenderFns } from "./Prebid.vue?vue&type=template&id=1af4088a"
import script from "./Prebid.vue?vue&type=script&lang=js"
export * from "./Prebid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports